import { accountsApi } from "@api";
import { sessionService } from "@services/sessionService";
import { tokenStore } from "@services/tokenStore";
import { Account, AccountExpand } from "@wingspanhq/wingspan-api-sdk";
import { useCallback } from "react";
import { useSelectSessionAccount } from "../../../modules/SelectOrganizationAccount/hooks/useSelectSessionAccount";

export const useBindAccountToSession = () => {
  const selectSessionAccount = useSelectSessionAccount();

  return useCallback(async (): Promise<Account> => {
    const boundAccountId = tokenStore.getIdentity()?.accountId;

    if (boundAccountId) {
      return accountsApi.getAccount({
        accountId: boundAccountId,
        expand: [AccountExpand.COMPLIANCE_ENTITY]
      });
    }

    const accounts = (await accountsApi.listAccounts()).data ?? [];

    if (accounts.length === 0) {
      const account = await accountsApi.createAccount({ accountCreate: {} });

      // `Account.id` is typed nullable by the v3 spec, but a just-created
      // account always carries one
      await sessionService.switchAccount(account.id!);

      return account;
    }

    await selectSessionAccount(accounts);

    const accountId = tokenStore.getIdentity()?.accountId;

    if (!accountId) {
      throw new Error("Session has no account bound");
    }

    return (
      accounts.find(account => account.id === accountId) ??
      (await accountsApi.getAccount({
        accountId,
        expand: [AccountExpand.COMPLIANCE_ENTITY]
      }))
    );
  }, [selectSessionAccount]);
};
